import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { useCreditCardCompareColumnContext } from '../../ColumnContext';
type DesktopContainerProps = {
  additionalProps?: BoxProps;
};
export function DesktopContainer(t0) {
  const $ = _c(6);
  const {
    additionalProps,
    children
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t1;
  if ($[0] !== index) {
    t1 = theme => ({
      borderLeft: index !== 0 ? `1px solid ${theme.palette.neutral.lighter}` : 0
    });
    $[0] = index;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== additionalProps || $[3] !== children || $[4] !== t1) {
    t2 = <Box pt={3} pb={5} sx={t1} {...additionalProps}>{children}</Box>;
    $[2] = additionalProps;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}